export const MODULE_SLUG_ACCOUNTS = 'accounts';
export const MODULE_SLUG_ADMINLOGS = 'adminlogs';
export const MODULE_SLUG_APIKEY = 'apikey';
export const MODULE_SLUG_BODYSTYLES = 'bodystyles';
export const MODULE_SLUG_DASHBOARD = 'dashboard';
export const MODULE_SLUG_DEALERCOMPARISON = 'dealercomparison';
export const MODULE_SLUG_DEALERPROFILE = 'dealerprofile';
export const MODULE_SLUG_DEFAULTGUIDES = 'defaultguides';
export const MODULE_SLUG_DOWNLOADREPORTS = 'downloadreports';
export const MODULE_SLUG_EDITFLAGS = 'editflags';
export const MODULE_SLUG_EDITTRACKER = 'edittracker';
export const MODULE_SLUG_EXPORT = 'export';
export const MODULE_SLUG_EXPORTDMS = 'exportdms';
export const MODULE_SLUG_IMPORTDMS = 'importdms';
export const MODULE_SLUG_WINDOW_STICKER_ORDER = 'window-sticker-order';
export const MODULE_SLUG_FEATUREBANNERLIBRARY = 'featurebannerlibrary';
export const MODULE_SLUG_FEATUREICONS = 'featureicons';
export const MODULE_SLUG_FILEMANAGER = 'filemanager';
export const MODULE_SLUG_LSPRATE = 'lsp-rate';
export const MODULE_SLUG_FLAGS = 'flags';
export const MODULE_SLUG_IMPORT = 'import';
export const MODULE_SLUG_INSTA360 = 'insta360';
export const MODULE_SLUG_EXT360 = 'ext360';
export const MODULE_SLUG_INVENTORY = 'inventory';
export const MODULE_SLUG_INVOICES = 'invoices';
export const MODULE_SLUG_INVOICESETTINGS = 'invoicesettings';
export const MODULE_SLUG_INVOICING = 'invoicing';
export const MODULE_SLUG_MASTERCOMPOSITIONS = 'mastercompositions';
export const MODULE_SLUG_MAVIS = 'mavis';
export const MODULE_SLUG_MAVISPRESETS = 'mavispresets';
export const MODULE_SLUG_YOUTUBETHUMBNAIL = 'youtubethumbnail';
export const MODULE_SLUG_PASETTINGS = 'pasettings';
export const MODULE_SLUG_PROFILES = 'profiles';
export const MODULE_SLUG_PROMOTIONALBANNER = 'promotionalbanner';
export const MODULE_SLUG_PROMOBILLBOARD = 'promobillboard';
export const MODULE_SLUG_QUALITYCONTROL = 'qualitycontrol';
export const MODULE_SLUG_REPORTSETTINGS = 'reportsettings';
export const MODULE_SLUG_REPORTSTATISTICS = 'reportstatistics';
export const MODULE_SLUG_RETROLAPPLYBG = 'retrolapplybg'; // delete this
export const MODULE_SLUG_RETROOPERATIONS = 'retrooperations';
export const MODULE_SLUG_USERROLES = 'userroles';
export const MODULE_SLUG_VIDEO = 'video';
export const MODULE_SLUG_DEVELOPER_ACCESS = 'developer-access';
export const MODULE_SLUG_ACCOUNTS_CREATION_PHOTOGRAPHER = 'accounts-creation-photographer';
export const MODULE_SLUG_VINSTATUS_TRACKER = 'vin-status-tracker';
export const MODULE_SLUG_INVOICE_EDIT_ACCESS = 'invoicesettings-edit-access';
export const MODULE_APP_GLOBAL = 'app-global';
export const MODULE_CRON_STATS = 'cron-stats';
export const MODULE_EDITOR_REPORT = 'editor-report';
export const MODULE_SOCIAL_MEDIA_INTEGRATION = 'social-media-integration';
export const MODULE_THEME_DOCS = 'theme-docs';
export const MODULE_MY_PROFILE = 'my-profile';
export const MODULE_VIN_TURNAROUND = 'vin-turnaround';
export const MODULE_VEH_UPLOAD_HISTORY = 'vehicle-upload-history';

// #region GLOBAL SETTING
export const MODULE_SLUG_WINDOW_STICKER_SETTING = 'window-sticker-setting';
export const MODULE_SLUG_BACKGROUND_REMOVAL_PLAYGROUND = 'background-removal-playground';

export const MODULE_SLUG_SALES = 'sales';
export const MODULE_SLUG_MANAGE_ANNOUNCEMENTS = 'manage-announcements';
export const MODULE_SLUG_GLOBAL_SETTINGS_ANALYTICS = 'global-settings-analytics';
export const MODULE_SLUG_GLOBAL_AP_SETTINGS = 'global-ap-settings';

// #region DEALER SETTINGS
export const MODULE_RATIO_SETTINGS = 'ratio-settings';
export const MODULE_SLUG_VIDEOGENERATION = 'videogeneration';
export const MODULE_SLUG_FEATUREBANNERS = 'featurebanners';
export const MODULE_SLUG_MAVISSETTINGS = 'mavissettings';
export const MODULE_SLUG_EXPORTORDER = 'exportorder';
export const MODULE_SLUG_PAGUIDESORDER = 'paguidesorder';
